/** Akıl widget bağlamı — sigorta dosyası / müvekkil / aracı detayından taşınır. */

const STORAGE_KEY = "mbs_akil_context";
const SON_HESAP_KEY = "mbs_akil_son_hesap";

const MODULE_LABELS = {
    aracilar: "Aracılar",
    muvekkiller: "Müvekkiller",
    "sigorta-dosyalari": "Sigorta Dosyaları",
    "deger-kaybi": "Değer Kaybı",
    odemeler: "Ödemeler",
    "whatsapp-merkez": "WhatsApp Merkez",
};

export function inferModuleFromPath(pathname = "") {
    const m = String(pathname || "").match(/^\/e\/([^/]+)(?:\/(\d+))?/);
    if (!m) return null;
    const slug = m[1];
    const id = m[2] ? Number(m[2]) : null;
    return {
        module: slug,
        module_label: MODULE_LABELS[slug] || slug,
        list_only: !id,
        entity_id: id,
    };
}

export function setAkilContext(ctx) {
    if (!ctx) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ctx));
}

export function getAkilContext() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        const stored = raw ? JSON.parse(raw) : null;
        const route = inferModuleFromPath(
            typeof window !== "undefined" ? window.location.pathname : "",
        );
        const sonHesap = getSonHesap();
        const base = { ...(route || {}), ...(stored || {}) };
        if (sonHesap) base.son_hesap = sonHesap;
        if (!stored && !route && !sonHesap) return null;
        return base;
    } catch {
        const route = inferModuleFromPath(
            typeof window !== "undefined" ? window.location.pathname : "",
        );
        const sonHesap = getSonHesap();
        if (!route && !sonHesap) return null;
        return { ...(route || {}), ...(sonHesap ? { son_hesap: sonHesap } : {}) };
    }
}

export function setSonHesap(hesap) {
    if (!hesap) {
        sessionStorage.removeItem(SON_HESAP_KEY);
        return;
    }
    sessionStorage.setItem(SON_HESAP_KEY, JSON.stringify(hesap));
}

export function getSonHesap() {
    try {
        const raw = sessionStorage.getItem(SON_HESAP_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function buildContextPrompt(ctx) {
    if (!ctx) return "";
    const parts = [];
    if (ctx.module_label) parts.push(`Modül: ${ctx.module_label}`);
    if (ctx.araci_label) parts.push(`Aracı: ${ctx.araci_label}`);
    if (ctx.muvekkil_label) parts.push(`Müvekkil: ${ctx.muvekkil_label}`);
    if (ctx.dosya_no) parts.push(`Dosya: ${ctx.dosya_no}`);
    if (ctx.plaka) parts.push(`Plaka: ${ctx.plaka}`);
    if (ctx.araci_id) parts.push(`AraciID: ${ctx.araci_id}`);
    if (ctx.sigorta_dosyasi_id) parts.push(`DosyaID: ${ctx.sigorta_dosyasi_id}`);
    if (ctx.muvekkil_id) parts.push(`MüvekkilID: ${ctx.muvekkil_id}`);
    if (!parts.length) return "";
    return `[Bağlam: ${parts.join(" · ")}] `;
}
